// extracted by mini-css-extract-plugin
export default {"homeOngoingContainer":"activeBookings_homeOngoingContainer__yW0Bc","noBookings":"activeBookings_noBookings__GS-FZ"};